import CryptoJS from 'crypto-js'
import axios from 'axios';
import commonstate from './constant.js';
import commonUtils from './workspace/common_util.js';
import store from '@/store';
import Vue from 'vue';
import quality from './quality_util';
import url from 'postcss-url';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default {
    //字符串AES加密
    strAESKeyEncrypt(str,key) {
        let encryp = CryptoJS.AES.encrypt(str, key).toString();
        return encryp;
    },
    //字符串AES解密
    strAESKeyDecrypt(str,key) {
        var decrypt = CryptoJS.AES.decrypt(str, key);
        return decrypt.toString(CryptoJS.enc.Utf8);
    },
    findsOptioniblings(elm) { //查找某个元素的所有兄弟元素
        let option = [];
        let p = elm.parentNode.children;
        for (let i = 0, pl = p.length; i < pl; i++) {
            if (p[i] !== elm) option.push(p[i]);
        }
        return option;
    },
    getAllCloudsList(callback,onlyEmail) {//获取用户名下的所有的云盘数据
        let that=this;
        let jsonList = [];
        commonstate.user = commonUtils.getUser();
        if(!commonstate.user){
            return;
        }
        let ud = commonUtils.getUser().id;
        let param={ ud: ud, sa: false };
        delete param.s;
        this.doDrivesRequest("list",param,{timeout:600000}).then(result => {//设置10分钟超时
            //console.log(param)
            if (result.status == 200) {
                let driveList =commonUtils.sortDriveName(result.drives);
                this.doDrivesRequest("list_categories", { ud: ud },{timeout:600000})//设置10分钟超时
                    .then(res => {
                        if (res.status == 200) {
                            let allCateGories=res.categories;
							//console.log(allCateGories);
                            var gsuiteCategoryId = null;
                            $.each(allCateGories, function(j, category) {
                                if ('gSuite' == category.appName && category.level > 0) {
                                    gsuiteCategoryId = category.id;
                                }
                            });
                            store.commit("setTeamCloud", {});
                            $.each(driveList, function(i, item) {
                                //添加team云盘信息
                                if(item.name == "Team" ||item.name == "团队"){
                                    store.commit("setTeamCloud", item);
                                    return;
                                }
                                // gsuite个人账号用gsuite图标显示
                                if(item.bucketName == 'gSuite'){
                                      item.categoryId = gsuiteCategoryId;
                                }
                                $.each(allCateGories, function(j, category) {
                                    if (item.categoryId == category.id && category.level > 0) {
										//console.log(category);
                                        jsonList.push({ appName: category.appName, categoryInfo: category, keyId: item.id + item.rootId, driveType: category.appName, name: item.name, id: item.id, rootId: item.rootId, methods: category.methods, driveInfo: item });
                                        return;
                                    }
                                });
                            });
                            callback(res);
                            commonstate.cloudCategories= that.removeRepeatCate(allCateGories);
                            store.state.cloudCategories =commonstate.cloudCategories;
                        }
                    });
            } else {
                callback(result);
            }
        });
        return jsonList;
    },
    removeRepeatCate(data){
        for(var i=0; i < data.length; i++) {
            for(var j=i+1; j < data.length; j++) {
             if(data[i].appName == data[j].appName) {
                if(data[i].id>data[j].id){
                    data.splice(j,1);
                    j--;
                }else{
                    data.splice(i,1);
                    i--;
                }

             }
            }
        }
        return data;
    },
    doUserRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/user/" + path, signAesKeyJson(data), options)
                .then(response => {
                    resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doShareRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/share/" + path, signAesKeyJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doVerifyCodeRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            get("/verify_code/" + path+"?vkey="+data.vkey, signAesKeyJson(data), options)
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
    },
    doBusinessTransferRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            post("/business_transfer/" + path, signSaltJson(data), options)
                .then(result => {
                  if(result.code >= 200 && result.code < 300){
                    resolve(result.data);
                  }
                  if(result.code >= 400 && result.code < 500){
                     reject(result)
                  }
                   if(result.code >= 500){
                     reject(result.message)
                   }
                }).catch(err =>{
                   reject(err)
                });
        })
    },
    generateVerifyKey() {
    	var len = 14;
    	var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    	var maxPos = $chars.length;
    	var codeKey = '';
    	for (var i = 0; i < len; i++) {
    	　　codeKey += $chars.charAt(Math.floor(Math.random() * maxPos));
    	}
    	var maxNum = 9;
    	var firstNum = Math.round(Math.random() * maxNum);
    	var lastNum = maxNum - firstNum;
    	codeKey = firstNum+codeKey+lastNum;
    	　return codeKey;
    },
    doUserStarRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/feedback/" + path, signSaltJson(data), options)
                .then(response => {
                    resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        });
    },
    doImageSaverRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/imagesaver" + path, signSaltJson(data), options)
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
    },
    doLiteRequest(path, data = {}, options = {}) {
        let user = commonUtils.getUser();
        data.ud = user.id;
        data.salt = user.salt;
        return new Promise((resolve, reject) => {
            post("/lite" + path, data, options)
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
    },
    doUserHaveLoginRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/user/" + path, signSaltJson(data), options)
                .then(response => {
                    resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        });
    },
    doDrivesRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/drives/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doFilesRequest(path, data = {}, options = {}) {
            return new Promise((resolve, reject) => {
                post("/files/" + path, signSaltJson(data), options)
                    .then(response => {
                       resolve(converToOldModel(response));
                    });
            })
    },
    doTasksRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/tasks/" + path, signSaltJson(data), options)
                .then(response => {
                    resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doEmailTasksRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/cloud_email_tasks/" + path, signSaltJson(data), options)
                .then(response => {
                    resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
	doRealtimeSyncRequest(path, data = {}, options = {}) {
	    return new Promise((resolve, reject) => {
	        post("/realtime_sync/" + path, signSaltJson(data), options)
	            .then(response => {
	                 resolve(converToOldModel(response));
	            }, err => {
	                reject(err);
	            });
	    })
	},
    doTorrentRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/torrent/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doEmailRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/email/" + path, signAesKeyJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doNotifyRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/notify/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doShareFileRequest(path, data = {}, options = {}) {
        if(data.ud){
            return new Promise((resolve, reject) => {
                post("/shareFile/" + path, signSaltJson(data), options)
                    .then(response => {
                         resolve(converToOldModel(response));
                    }, err => {
                        reject(err);
                    });
            })

        }else{
            return new Promise((resolve, reject) => {
                post("/shareFile/" + path, signAesKeyJson(data), options)
                    .then(response => {
                         resolve(converToOldModel(response));
                    }, err => {
                        reject(err);
                    });
            })
        }
    },
    doInviteFriendsRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/invite/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doSubAccountRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/subaccount/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doPermissionRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/permission/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doDualVerifyRequest(path, data = {}, options = {}){
      data.al = true;
        return new Promise((resolve, reject) => {
            post("/dual_verify/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doDualVerifyAesRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            post("/dual_verify/" + path, signAesKeyJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    doSubscriptionGetRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            cBpost("/subscription/" + path,data, options)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            });
        });
    },
    doCbSubscriptionPostRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            cBpost("/subscription/" + path,data, options)
            .then(response => {
                resolve(converToOldModel(response));
            }, err => {
                reject(err);
            });
        });
    },
    doSubscriptionPostRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            post("/subscription/" + path,signSaltJson(data), options)
            .then(response => {
                 resolve(converToOldModel(response));
            }, err => {
                reject(err);
            });
        });
    },
    doSubinquiryPostRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            post("/subinquiry/" + path,signSaltJson(data), options)
            .then(response => {
                resolve(converToOldModel(response));
            }, err => {
                reject(err);
            });
        });
    },
    doBackupRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            post("/backup/" + path,data, options)
            .then(response => {
                 resolve(converToOldModel(response));
            }, err => {
                reject(err);
            });
        });
    },
    doCloudEmailRequest(path, data = {}, options = {}) {
        return new Promise((resolve, reject) => {
            post("/cloud_email/" + path, signSaltJson(data), options)
                .then(response => {
                     resolve(converToOldModel(response));
                }, err => {
                    reject(err);
                });
        })
    },
    openWin(result) {
        return new Promise((resolve, reject) => {
            if (result.status == 201) {
                axios.get(commonstate.apiUrl + "/drives/auth?state=" + result.state).then(response => {
                    window.location.href = converToOldModel(decrypt(response.data)).authUrl;
                });
            }
        });
    },
    openNewWin(result){
        axios.get(commonstate.apiUrl + "/drives/auth?state=" + result.state).then(response => {
            let windowLeft = (window.screenX || window.screenLeft || 0) + (screen.width - 441) / 2;
            let windowItem = window.open(converToOldModel(decrypt(response.data)).authUrl,'newwindow','left='+windowLeft+',height=632, width=441, top=200,  toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no');
        });
    },
    doProgressRequest(path, data = {}, config, callback) {
        doProgressPost(path, signSaltJson(data), config, function(response) {
            callback(converToOldModel(response));
        });
    },
    doUploadProgressRequest(path, data = {}, config, callback) {
        doUploadProgressPost(path, signSaltJson(data), config, function(response) {
            callback(converToOldModel(response));
        });
    },
    doAcvieTagRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            post("/active_tag/" + path,signSaltJson(data), options)
            .then(response => {
                 resolve(response);
            }, err => {
                reject(err);
            });
        });
    },
    doWebPostRequest(path, data = {}, options = {}){
        return new Promise((resolve, reject) => {
            webpost(path,data, options)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            });
        });
    },
    doMCGARequest(data = {}) {
        //MC内部GA打点使用
        let user = commonUtils.getUser();
        if(!user) return;
        data.ud = user.id;
        return new Promise((resolve, reject) => {
            post("/imagesaver/ga", signSaltJson(data))
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
    },
    formatByteSpeed: function(bytes) {
        if (bytes == 0) { return 0 + 'Bytes'; } else if (!bytes) {
            return 0;
        }
        if (bytes < 0) {
            return 0;
        } else if (bytes < 1024) {
            return Math.floor(bytes) + "Bytes/s";
        } else if (bytes < 1024 * 1024) {
            return Math.floor(bytes / 1024 * 100) / 100 + "KB/s";
        } else if (bytes < 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 * 100) / 100 + "MB/s";
        } else if (bytes < 1024 * 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 / 1024 * 100) / 100 + "GB/s";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "TB/s";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "PB/s";
        } else {
            return Math.floor(bytes / 1024 / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "EB/s";
        }
    },
    fromatSpeedBytes: function(value) {
        if (value == undefined || value == 0) {
            return "Unknown";
        } else if (value.indexOf("Bytes/s") >= 0) {
            return value.replace('Bytes/s', '');
        } else if (value.indexOf("KB/s") >= 0) {
            return value.replace('KB/s', '') * 1024;
        } else if (value.indexOf("MB/s") >= 0) {
            return value.replace('MB/s', '') * 1024 * 1024;
        } else if (value.indexOf("GB/s") >= 0) {
            return (value.replace('GB/s', '')) * 1024 * 1024 * 1024;
        } else if (value.indexOf("TB/s") >= 0) {
            return value.replace('TB/s', '') * 1024 * 1024 * 1024 * 1024;
        } else if (value.indexOf("PB/s") >= 0) {
            return value.replace('PB/s', '') * 1024 * 1024 * 1024 * 1024 * 1024;
        } else if (value.indexOf("EB/s") >= 0) {
            return value.replace('EB/s', '') * 1024 * 1024 * 1024 * 1024 * 1024 * 1024;
        }
    },
    signAesKeyJson,
    signSaltJson,
    signMd5,
    decrypt,
    cBget
}

//解密方法
function decrypt(data) {
    let _key = commonstate.KEY;
    let key = CryptoJS.enc.Base64.parse(_key);
    let encryptedHexStr = CryptoJS.format.Hex.parse(data);
    let decryptedData = CryptoJS.AES.decrypt(encryptedHexStr, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    let decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);
    if (decryptedStr) {
        return JSON.parse(decryptedStr);
    } else {
        return data;
    }
}

// 转换回原来的数据格式
function converToOldModel(response){
    let result = response;
    if(response.code >= 200 && response.code < 300){
        result = response.data;
        if(result){
            if(!result.message){
                result.message = response.message;
            }
            if(!result.status){
                result.status = response.code;
            }
        }else{
            result = {
                message: response.message,
                status:response.code
            };
        }
    }
  if(response.code >= 400 && response.code < 500){
    result = {
      status: response.code,
      msg: response.message,
      reason: response.reason
    }
  }
  if(response.code >= 500){
    result = {
      status: response.code,
      msg: response.message,
    }
  }
  return result;
}

//登录之后请求采用md5的salt加密;如果json中包含salt,直接加密json
function signSaltJson(json) {
    let user = localStorage.getItem("user");
    var salt = json.salt || user && JSON.parse(user).salt;
    return signJson(json, "salt", salt);
}

//登录之前请求采用md5的aesKey加密
function signAesKeyJson(json) {
    let _key = commonstate.ENCRYPT_KEY;
    return signJson(json, "aesKey", _key);
}

//进行MD5加密
function signJson(json, key, val) {
    if (json[key]) {
        json["s"] = signMd5(json);
    } else if (val) {
        json[key] = val;
        json["s"] = signMd5(json);
        delete json[key];
    }
    return json;
}

function signMd5(json) {
    let keys = [];
    for (var i in json) {
        keys.push(i);
    }
    keys = keys.sort();
    let str = '';
    let len = keys.length;
    for (let i = 0; i < len; i++) {
        str += keys[i] + inspectObj(json[keys[len - i - 1]]);
    }
    let md5Str = CryptoJS.MD5(str).toString();
    md5Str = md5Str.substring(1, md5Str.length - 2); //去掉第一位和最后两位
    return md5Str;
}
//如果值为一个对象，将值设为转成有序字符串的md5
function inspectObj(val) {
    if (val instanceof Object && typeof val == 'object') {
        var jsonStr = JSON.stringify(val);
        if(jsonStr){
            // var segmenter = new Intl.Segmenter("en-US", { granularity: "grapheme" });
            // var arr = Array.from(
            //     segmenter.segment(jsonStr),
            //     s => s.segment
            // )
            var arr = str2arr(jsonStr);
            arr.sort();
            var arrStr = arr.join('');
            return CryptoJS.MD5(arrStr).toString();
        }
        return "";
    }
    return val;
}
// 字符串转字符数组
function str2arr(str) {
    var arr = [];
    var temp = "";
    for(var i=0,len=str.length; i<len; i++) {
        if(str.charCodeAt(i) > 255) {
            // 非简单字符，暂存到temp，等会push
            temp += str[i];
        }else {
            // 把包含非简单字符的temp，push到arr，并清空temp
            if(temp != "") {
                arr.push(temp);
                temp = "";
            }
            // 正常字符，正常push
            arr.push(str[i]);
        }
    }
    // 把包含非简单字符的temp，push到arr，并清空temp
    if(temp != "") {
        arr.push(temp);
        temp = "";
    }
    return arr;
}

//用户post请求返回数据采用aes解密
function post(url, data, options = {}) {
    //判断包含shar.multcloud.link则修改后端api地址
    var api = getApiUrl();
    return new Promise((resolve, reject) => {
        axios.post(api + url, data, quality.config(options && options.quality))
            .then(response => {
              resolve(decrypt(response.data));
            }, err => {
                reject(err);
            });
    })
}

function get(url, data, options = {}) {
    var api = getApiUrl();
    return new Promise((resolve, reject) => {
        axios.get(api + url, quality.config(options && options.quality, data))
            .then(response => {
                resolve((response.data));
            }, err => {
                reject(err);
            });
    })
}

function doProgressPost(path, formData, config, callback) {
    let cancelToken = axios.CancelToken;
    commonstate.source = cancelToken.source();
    config.cancelToken = commonstate.source.token;
    let api = getApiUrl();
    axios.post(api + path, formData, quality.config(config.quality || config.mcQuality, config))
        .then(response => {
            decrypt(response.data);
            callback(decrypt(response.data));
        }).catch(function(error) {
            if (axios.isCancel(error)) { //主要是这里

            }
            callback(error);
        });
}

//获取cb的get请求
function cBget(url, data) {
    return new Promise((resolve, reject) => {
        axios.get(commonstate.apiUrl + url, data)
        .then(response => {
            resolve((response.data));
        }, err => {
            reject(err);
        });
    })
}
//发送给cb的post请求
function cBpost(url, data, options = {}) {
    return new Promise((resolve, reject) => {
        axios.post(commonstate.apiUrl + url, data, quality.config(options && options.quality))
            .then(response => {
                resolve((response.data));
            }, err => {
                reject(err);
            });
    })
}

//发送给网站部的post请求
function webpost(url, data, options = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, quality.config(options && options.quality))
            .then(response => {
                resolve((response.data));
            }, err => {
                reject(err);
            });
    })
}

//上传文件专用
function doUploadProgressPost(path, formData, config, callback) {
    let cancelToken = axios.CancelToken;
    commonstate.source = cancelToken.source();
    config.cancelToken = commonstate.source.token;
    axios.post(commonstate.uploadUrl + path, formData, quality.config(config.quality || config.mcQuality, config))
        .then(response => {
            decrypt(response.data);
            callback(decrypt(response.data));
        }).catch(function(error) {
            if (axios.isCancel(error)) { //主要是这里

            }
            callback(error);
        });
}

function getApiUrl() {
    //判断包含shar.multcloud.link则修改后端api地址
    var url = window.location.host;
    if(commonstate.sharePageApiUrl != null && commonstate.sharePageApiUrl.indexOf(url)>0){
        url = commonstate.sharePageApiUrl+"/api";
    }else{
        url = commonstate.apiUrl;
    }
    return url;
}



// WEBPACK FOOTER //
// ./src/js/request_util.js